var _excluded = ["label", "promo", "tooltip", "logo", "title", "description", "oldPrice", "price", "button", "buttonColor", "buttonVariant"],
  _excluded2 = ["text", "dataTestId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
import breakpoint from "../../../utils/breakpoint";
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import isNotEmpty from "../../../utils/isNotEmpty";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import ButtonAtm from "../../atoms/ButtonAtm";
import LabelAtm from "../../atoms/LabelAtm";
import TextAtm from "../../atoms/TextAtm";
import BreakpointVisibilityOrg from "../../organisms/BreakpointVisibilityOrg";
import PushOrg from "../../organisms/PushOrg";
import WrapOrg from "../../organisms/WrapOrg";
import Picture from "../../quarks/Picture";
import RegularPriceMol from "../RegularPriceMol/RegularPriceMol";
import TooltipMol from "../TooltipMol";
export var defaultProps = {
  buttonColor: "secondary",
  buttonVariant: "transparent"
};
var breakpointValue = "medium";
var Box = styled.div.withConfig({
  componentId: "sc-kz18wc-0"
})(function (_ref) {
  var $onColor = _ref.$onColor,
    theme = _ref.theme;
  return css(["display:flex;flex-direction:column;flex-grow:1;padding:", " ", ";border:", " solid ", ";border-radius:", ";"], space(3), space(2.5), unit(1), getBorderColor(theme, $onColor, "low"), getBorderRadius(theme, "small"));
});
var Header = styled.div.withConfig({
  componentId: "sc-kz18wc-1"
})(function (_ref2) {
  var $hasLabelOrPromo = _ref2.$hasLabelOrPromo;
  return css(["display:flex;align-items:flex-start;justify-content:space-between;margin-bottom:", ";", "{margin-bottom:", ";}", ""], space(2.5), breakpoint(breakpointValue), space(3), !$hasLabelOrPromo && css(["justify-content:flex-end;"]));
});
var Logo = styled(Picture).withConfig({
  componentId: "sc-kz18wc-2"
})(["align-self:center;margin-left:", ";"], space(3));
var Description = styled(TextAtm).withConfig({
  componentId: "sc-kz18wc-3"
})(["flex-grow:1;"]);
function ProductTileMol(_ref3) {
  var label = _ref3.label,
    promo = _ref3.promo,
    tooltip = _ref3.tooltip,
    logo = _ref3.logo,
    title = _ref3.title,
    description = _ref3.description,
    oldPrice = _ref3.oldPrice,
    price = _ref3.price,
    button = _ref3.button,
    _ref3$buttonColor = _ref3.buttonColor,
    buttonColor = _ref3$buttonColor === void 0 ? defaultProps.buttonColor : _ref3$buttonColor,
    _ref3$buttonVariant = _ref3.buttonVariant,
    buttonVariant = _ref3$buttonVariant === void 0 ? defaultProps.buttonVariant : _ref3$buttonVariant,
    restProps = _objectWithoutProperties(_ref3, _excluded);
  var buttonText = button.text,
    dataTestId = button.dataTestId,
    restButtonProps = _objectWithoutProperties(button, _excluded2);
  var hasLabelOrPromo = !!label || !!promo;
  var onColor = useContext(OnColorContext);
  var headerJSX = /*#__PURE__*/React.createElement(Header, {
    $hasLabelOrPromo: hasLabelOrPromo
  }, hasLabelOrPromo ? /*#__PURE__*/React.createElement(WrapOrg, {
    gutterSpace: {
      small: 0.5,
      medium: 1,
      large: 1
    },
    alignCenter: "vertical"
  }, isNotEmpty(label) ? /*#__PURE__*/React.createElement(LabelAtm, {
    variant: label.variant || "notify"
  }, label.children) : null, !!promo && /*#__PURE__*/React.createElement(LabelAtm, null, promo), !!tooltip && /*#__PURE__*/React.createElement(TooltipMol, null, tooltip)) : null, /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: breakpointValue
  }, /*#__PURE__*/React.createElement(Logo, {
    srcData: logo,
    alt: logo.alt
  })));
  return /*#__PURE__*/React.createElement(Box, _extends({
    $onColor: onColor
  }, restProps), hasLabelOrPromo ? headerJSX : /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: breakpointValue
  }, headerJSX), /*#__PURE__*/React.createElement(PushOrg, {
    bottomSpace: {
      small: 1.5,
      medium: 1,
      large: 1
    }
  }, title), /*#__PURE__*/React.createElement(Description, {
    typography: "xsmall1",
    emphasis: "medium",
    pushSpace: 4
  }, description), !!oldPrice && /*#__PURE__*/React.createElement(TextAtm, {
    typography: "nano1",
    emphasis: "low",
    pushSpace: 0.5,
    hasLineThrough: true
  }, oldPrice), /*#__PURE__*/React.createElement(PushOrg, {
    bottomSpace: {
      small: 2,
      medium: 3,
      large: 3
    }
  }, /*#__PURE__*/React.createElement(RegularPriceMol, _extends({}, price, {
    hasTextColor: !oldPrice,
    isSmall: true
  }))), /*#__PURE__*/React.createElement(ButtonAtm, _extends({}, restButtonProps, {
    color: buttonColor,
    variant: buttonVariant,
    size: "small",
    "data-test-id": dataTestId,
    isExpanded: true
  }), buttonText));
}
export default ProductTileMol;